module.exports = __webpack_public_path__ + "static/media/YF63_2.2b4bcbec.jpg";